<template>
  <v-app>
    <div class="animated fadeIn">

      <ddoWaiting :value="loading" :message="$t('texts.loading')"/>

      <div id="switchcustomer">
         <v-row>
            <v-col>
               <ddoSelectSwitchCustomer ref="mySelect"
                  @switchCustomer="refresh_page"
               >
               </ddoSelectSwitchCustomer>
            </v-col>
         </v-row>
      </div>

      <b-card>
         <b-tabs>

            <b-tab id="chapter1" active>
               <template slot="title">
                  <big><i class="icon-list"></i> {{ $t('titles.synthesis') }}</big>
               </template>

               <v-card>
                  <v-card-title class="headline grey lighten-1">
                     <v-icon>mdi-chart</v-icon>
                     {{ $t('titles.synthesis') }}
                  </v-card-title>
                  <v-card-text>
                     <ddoClientList :loading="loading" :level="levels[0]" :childKey="levels[0].childKey"
                     :columns="levels[0].columns" :options="levels[0].options" :callbacks="levels[0].callbacks" :customSlotNames="levels[0].customSlotNames" ref="mySynthesisList"
                     >
                        <template slot="_create" slot-scope="props">
                           <slot name="_create" v-scope="props">
                              <p>{{ $api._d(props.row._create,'short') }}</p>
                           </slot>
                        </template>

                        <template v-slot:header="slotProps">
                           <span></span>
                        </template>

                        <template slot="c_smtp_log_day" slot-scope="props">
                           <span>{{ $api._d(props.row.c_smtp_log_day,'fulldaymonth') }}</span>
                        </template>

                        <template slot="status_sent" slot-scope="props">
                           <v-chip v-if="props.row.status_sent>0"
                              color="green"
                           >
                              <strong>{{ props.row.status_sent }}</strong>
                           </v-chip>
                        </template>

                        <template slot="status_bounced" slot-scope="props">
                           <v-chip v-if="props.row.status_bounced>0"
                              color="red"
                           >
                              <strong>{{ props.row.status_bounced }}</strong>
                           </v-chip>
                        </template>

                        <template slot="status_expired" slot-scope="props">
                           <v-chip v-if="props.row.status_expired>0"
                              color="red"
                           >
                              <strong>{{ props.row.status_expired }}</strong>
                           </v-chip>
                        </template>

                        <template slot="status_deferred" slot-scope="props">
                           <v-chip v-if="props.row.status_deferred>0"
                              color="orange"
                           >
                              <strong>{{ props.row.status_deferred }}</strong>
                           </v-chip>
                        </template>

                        <template slot="n_smtp_log_avg" slot-scope="props">
                           <span v-if="props.row.n_smtp_log_avg!=null">{{ props.row.n_smtp_log_avg.toFixed(2) }} sec.</span>
                        </template>

                        <template slot="status_graph" slot-scope="props">
                           <ddoGraphPie class="graphcontainer" :ref="buildRef(props.row)" :chartData="PIEchartdata(props.row)" :options="PIEoptions"/>
                        </template>

                        <template v-slot:superheader="slotProps">
                           <h3>{{ $t('subtitles.synthesis_count_per_status_on_last_days') }}</h3>
                           <ddoSelect2
                              :callbacks="PLFcallbacks"
                              :options="PLFoptions"
                              ref="myPLFSelect1"
                              @itemsLoaded="after_refresh_plf"
                           >
                              <template v-slot:selection="data">
                                 <v-chip
                                    v-bind="data.attrs"
                                    :input-value="data.selected"
                                    close
                                    @click:close="$refs.myPLFSelect1.remove(data.item)"
                                 >
                                    <span v-text="data.item.xxx_sasl_usernames"></span>
                                 </v-chip>
                              </template>
                              <template v-slot:item="data">
                                 <v-list-item-content>
                                    <v-list-item-title v-html="data.item.xxx_sasl_usernames"></v-list-item-title>
                                    <v-list-item-subtitle v-html="data.item.cus_name"></v-list-item-subtitle>
                                 </v-list-item-content>
                              </template>
                           </ddoSelect2><br>
                        </template>
                     </ddoClientList>
                  </v-card-text>
               </v-card>

            </b-tab>

            <b-tab id="chapter2">
               <template slot="title">
                  <big><i class="icon-chart"></i> {{ $t('titles.graphs') }}</big>
               </template>

               <v-card>
                  <v-card-title class="headline grey lighten-1">
                     <v-icon>mdi-chart</v-icon>
                     {{ $t('titles.graphs') }}
                  </v-card-title>
                  <v-card-text>
                     <v-row :hide-default-header="false">
                        <v-col cols="3" sm="3">    
                           <TileSimple name="Tile0" :values="charts[0]">
                              <template v-slot:title>
                                 <h4>{{ charts[0].value }}  {{ charts[0].unit }}</h4>
                              </template>
                              <template v-slot:header>
                                 {{ charts[0].message }}
                              </template>
                              <template v-slot:message>
                                 <span></span>
                              </template>
                              <template v-slot:graph>
                                 <ddoGraphBar v-if="loaded_standard" ref="myGraphLine0" key="myGraphLine0" :chartdata="charts[0].chartdata" :options="charts[0].options" :height="height"/>
                              </template>
                           </TileSimple>
                        </v-col>

                        <v-col cols="3" sm="3">    
                           <TileSimple name="Tile1" :values="charts[1]">
                              <template v-slot:title>
                                 <h4>{{ charts[1].value }} {{ charts[1].unit }}</h4>
                              </template>
                              <template v-slot:header>
                                 {{ charts[1].message }}
                              </template>
                              <template v-slot:message>
                                 <span></span>
                              </template>
                              <template v-slot:graph>
                                 <ddoGraphBar v-if="loaded_standard" ref="myGraphLine1" key="myGraphLine1" :chartdata="charts[1].chartdata" :options="charts[1].options" :height="height"/>
                              </template>
                           </TileSimple>
                        </v-col>

                        <v-col cols="3" sm="3">    
                           <TileSimple name="Tile2" :values="charts[2]">
                              <template v-slot:title>
                                 <h4>{{ charts[2].value }} {{ charts[2].unit }}</h4>
                              </template>
                              <template v-slot:header>
                                 {{ charts[2].message }}
                              </template>
                              <template v-slot:message>
                                 <span></span>
                              </template>
                              <template v-slot:graph>
                                 <ddoGraphBar v-if="loaded_standard" ref="myGraphLine2" key="myGraphLine2" :chartdata="charts[2].chartdata" :options="charts[2].options" :height="height"/>
                              </template>
                           </TileSimple>
                        </v-col>

                        <v-col cols="3" sm="3">    
                           <TileSimple name="Tile3" :values="charts[3]">
                              <template v-slot:title>
                                 <h4>{{ charts[3].value }} {{ charts[3].unit }}</h4>
                              </template>
                              <template v-slot:header>
                                 {{ charts[3].message }}
                              </template>
                              <template v-slot:message>
                                 <span></span>
                              </template>
                              <template v-slot:graph>
                                 <ddoGraphBar v-if="loaded_standard" ref="myGraphLine3" key="myGraphLine3" :chartdata="charts[3].chartdata" :options="charts[3].options" :height="height"/>
                              </template>
                           </TileSimple>
                        </v-col>
                     </v-row>

                     <v-row :hide-default-header="false">
                        <v-col cols="3" sm="3">    
                           <TileSimple name="Tile4" :values="charts[4]">
                              <template v-slot:title>
                                 <h4>{{ charts[4].value }} {{ charts[4].unit }}</h4>
                              </template>
                              <template v-slot:header>
                                 {{ charts[4].message }}
                              </template>
                              <template v-slot:message>
                                 <span></span>
                              </template>
                              <template v-slot:graph>
                                 <ddoGraphBar v-if="loaded_standard" ref="myGraphLine4" key="myGraphLine4" :chartdata="charts[4].chartdata" :options="charts[4].options" :height="height"/>
                              </template>
                           </TileSimple>
                        </v-col>

                        <v-col cols="3" sm="3">    
                           <TileSimple name="Tile5" :values="charts[5]">
                              <template v-slot:title>
                                 <h4>{{ charts[5].value }} {{ charts[5].unit }}</h4>
                              </template>
                              <template v-slot:header>
                                 {{ charts[5].message }}
                              </template>
                              <template v-slot:message>
                                 <span></span>
                              </template>
                              <template v-slot:graph>
                                 <ddoGraphBar v-if="loaded_standard" ref="myGraphLine5" key="myGraphLine5" :chartdata="charts[5].chartdata" :options="charts[5].options" :height="height"/>
                              </template>
                           </TileSimple>
                        </v-col>

                        <v-col cols="3" sm="3">    
                           <TileSimple name="Tile6" :values="charts[6]">
                              <template v-slot:title>
                                 <h4>{{ charts[6].value }} {{ charts[6].unit }}</h4>
                              </template>
                              <template v-slot:header>
                                 {{ charts[6].message }}
                              </template>
                              <template v-slot:message>
                                 <span></span>
                              </template>
                              <template v-slot:graph>
                                 <ddoGraphBar v-if="loaded_standard" ref="myGraphLine6" key="myGraphLine6" :chartdata="charts[6].chartdata" :options="charts[6].options" :height="height"/>
                              </template>
                           </TileSimple>
                        </v-col>

                        <v-col cols="3" sm="3">    
                           <TileSimple name="Tile7" :values="charts[7]">
                              <template v-slot:title>
                                 <h4>{{ charts[7].value }} {{ charts[7].unit }}</h4>
                              </template>
                              <template v-slot:header>
                                 {{ charts[7].message }}
                              </template>
                              <template v-slot:message>
                                 <span></span>
                              </template>
                              <template v-slot:graph>
                                 <ddoGraphBar v-if="loaded_standard" ref="myGraphLine7" key="myGraphLine7" :chartdata="charts[7].chartdata" :options="charts[7].options" :height="height"/>
                              </template>
                           </TileSimple>
                        </v-col>
                     </v-row>
                  </v-card-text>
               </v-card>

               <v-card>
                  <v-card-title class="headline grey lighten-1">
                     <v-icon>mdi-chart-line</v-icon>
                     {{ $t('titles.zoom_graph') }}
                     <template>
                        <ddoSelect2
                           :callbacks="GRAPHcallbacks"
                           :options="GRAPHoptions"
                           ref="myGRAPHSelect"
                           @itemsLoaded="after_refresh_plf"
                        >
                           <template v-slot:selection="data">
                              <v-chip
                                 v-bind="data.attrs"
                                 :input-value="data.selected"
                              >
                                 <span v-text="data.item.text"></span>
                              </v-chip>
                           </template>
                           <template v-slot:item="data">
                              <v-list-item-content>
                                 <v-list-item-title v-html="data.item.text"></v-list-item-title>
                              </v-list-item-content>
                           </template>
                        </ddoSelect2>
                     </template>
                     
                      {{ $t('titles.for_account') }}
                     
                     <template>
                        <ddoSelect2
                           :callbacks="ACCOUNTcallbacks"
                           :options="ACCOUNToptions"
                           ref="myACCOUNTSelect"
                           @itemsLoaded="after_refresh_plf"
                        >
                           <template v-slot:selection="data">
                              <v-chip
                                 v-bind="data.attrs"
                                 :input-value="data.selected"
                                 close
                                 @click:close="$refs.myACCOUNTSelect.remove(data.item)"
                              >
                                 <span v-text="data.item.xxx_sasl_usernames"></span>
                              </v-chip>
                           </template>
                           <template v-slot:item="data">
                              <v-list-item-content>
                                 <v-list-item-title v-html="data.item.xxx_sasl_usernames"></v-list-item-title>
                                 <v-list-item-subtitle v-html="data.item.cus_name"></v-list-item-subtitle>
                              </v-list-item-content>
                           </template>
                        </ddoSelect2>
                     </template>
                  </v-card-title>
                  <v-card-text>
                     <ddoGraphBar v-if="loaded_per_status" ref="myGraphperStatus" :chartdata="charts[8].chartdata" :options="ZOOMoptions" :height="height"/>
                  </v-card-text>
               </v-card>

            </b-tab>
           
            <b-tab id="chapter3">
               <template slot="title">
                  <big><i class="icon-settings"></i> {{ $t('titles.search') }}</big>
               </template>
               <v-card>
                  <v-card-title class="headline grey lighten-1">
                     <v-icon>mdi-search-web</v-icon>
                     {{ $t('titles.search_mails_out') }}
                  </v-card-title>
                  <v-card-text>
                     <v-form v-model="isFormValid">
                        <h3>{{ $t('subtitles.search_criteria') }}</h3>
                        <v-row :hide-default-header="false">
                           <v-col cols="6" sm="6">
                              <h4>{{ $t('subtitles.search_account') }}</h4>
                              <ddoSelect2
                                 :callbacks="PLFcallbacks"
                                 :options="PLFoptions"
                                 ref="myPLFSelect"
                                 @itemsLoaded="after_refresh_plf"
                              >
                                 <template v-slot:selection="data">
                                    <v-chip
                                       v-bind="data.attrs"
                                       :input-value="data.selected"
                                       close
                                       @click:close="$refs.myPLFSelect.remove(data.item)"
                                    >
                                       <span v-text="data.item.xxx_sasl_usernames"></span>
                                    </v-chip>
                                 </template>
                                 <template v-slot:item="data">
                                    <v-list-item-content>
                                       <v-list-item-title v-html="data.item.xxx_sasl_usernames"></v-list-item-title>
                                       <v-list-item-subtitle v-html="data.item.cus_name"></v-list-item-subtitle>
                                    </v-list-item-content>
                                 </template>
                              </ddoSelect2>
                              <br/><br/>
                              <h4>{{ $t('subtitles.search_status') }}</h4>
                              <ddoSelect2
                                 :callbacks="STATUScallbacks"
                                 :options="STATUSoptions"
                                 ref="mySTATUSSelect"
                              >
                                 <template v-slot:selection="data">
                                    <v-chip
                                       v-bind="data.attrs"
                                       :input-value="data.selected"
                                    >
                                       <span v-text="data.item.status_label"></span>
                                    </v-chip>
                                 </template>
                                 <template v-slot:item="data">
                                    <v-list-item-content>
                                       <v-list-item-title v-html="data.item.status_label"></v-list-item-title>
                                       <v-list-item-subtitle v-html="data.item.status_code"></v-list-item-subtitle>
                                    </v-list-item-content>
                                 </template>
                              </ddoSelect2>
                           </v-col>
                           <v-col cols="6" sm="6">
                              <h4>{{ $t('subtitles.search_daterange') }}</h4>
                              {{ $t('subtitles.search_selecteddaterange') }}<v-chip color="default" >{{datesFormatted}}</v-chip><br/>
                              <v-date-picker
                                 v-model="dates"
                                 no-title
                                 :range="false"
                                 :allowed-dates="getAllowedDates"              
                                 :locale="locale"
                                 elevation="15"
                              >
                              </v-date-picker>
                           </v-col>
                        </v-row>
                        <v-row>
                           <v-col cols="6" sm="6">
                              <h4>{{ $t('subtitles.search_sender') }}</h4>
                              <v-text-field dense v-model="search_radix_from" maxlength="80" :prefix="$t('texts.search_start_with')" :label="$t('texts.search_radix_from')" >
                              </v-text-field>
                              <v-text-field dense v-model="search_domain_from" maxlength="80" prefix="@" :label="$t('texts.search_domain_from')" >
                              </v-text-field>
                           </v-col>
                           <v-col cols="6" sm="6">
                              <h4>{{ $t('subtitles.search_recipient') }}</h4>
                              <v-text-field dense v-model="search_radix_to" maxlength="80" :prefix="$t('texts.search_start_with')" :label="$t('texts.search_radix_to')" >
                              </v-text-field>
                              <v-text-field dense v-model="search_domain_to" maxlength="80" prefix="@" :label="$t('texts.search_domain_to')" >
                              </v-text-field>
                           </v-col>
                        </v-row>
                        <h4>{{ $t('texts.smtppro_search_and_export') }} :</h4>
                        <v-btn class="primary" rounded @click="search_mails" :disabled="!isFormValid">{{ $t('buttons.search') }}</v-btn>
                        <v-btn class="primary" rounded @click="export_mails" :disabled="search_results.length==0">{{ $t('buttons.export_csv') }}</v-btn>
                        <br/><br/>
                        <h4>{{ $t('texts.smtppro_direct_monthly_export') }} :</h4>
                        <v-btn class="primary" rounded @click="export_month_mails">{{ exportButtonText }}</v-btn>
                        <br/>
                     </v-form>
                  </v-card-text>
               </v-card>
               <div v-if="searching">
                  <v-card>
                     <v-card-title class="headline grey lighten-1">
                        <v-icon>mdi-search-web</v-icon>
                        {{ $t('subtitles.search_results') }}
                     </v-card-title>
                     <v-card-text>
                        <ddoAlert :errors="search_errors"/> 
                        <v-data-table v-if="search_results.length>0"
                           dense
                           :headers="search_headers"
                           :items="search_results"
                           item-key="_pk"
                            :footer-props="{
                              itemsPerPageOptions: [50,100,200,500,-1]
                           }"
                       >
                           <template v-slot:item.c_smtp_log_messageid="{ item }">
                              <v-btn color="primary" class="text-none" rounded @click="search_message(item.c_smtp_log_messageid)">{{item.c_smtp_log_messageid}}</v-btn>
                              <v-dialog v-model="showMessageDetail" data-app="true" hide-overlay persistent scrollable max-width="60%" elevation="0">
                                 <v-card>
                                    <v-card-title class="headline grey lighten-2">
                                       Message {{current_messageid}}
                                       <v-spacer></v-spacer>
                                       <v-icon @click="showMessageDetail=false">mdi-close</v-icon>
                                    </v-card-title>
                                    <v-card-text>

                                       <ddoAlert :errors="message_errors"/> 

                                       <v-data-table
                                          dense
                                          :headers="message_headers"
                                          :items="message_results"
                                          item-key="_pk"
                                          :footer-props="{
                                             itemsPerPageOptions: [30,520,100,-1]
                                          }"
                                       >
                                          <template v-slot:item.c_smtp_log_server="{ item }">
                                             {{ shorten_servername(item.c_smtp_log_server) }}
                                          </template>
                                          <template v-slot:item.comments="{ item }">
                                             ==> <div v-html="item.comments"></div>
                                          </template>
                                       </v-data-table>

                                    </v-card-text>
                                 </v-card>
                              </v-dialog>
                           </template>

                           <template v-slot:item.c_smtp_log_server="{ item }">
                              {{ shorten_servername(item.c_smtp_log_server) }}
                           </template>

                           <template v-slot:item.comments="{ item }">
                              <div v-html="item.comments"></div>
                           </template>

                        </v-data-table>
                     </v-card-text>
                  </v-card>
               </div>
            </b-tab>

            <b-tab id="chapter4">
               <template slot="title">
                  <big><i class="icon-settings"></i> {{ $t('titles.settings_spf_dkim') }}</big>
               </template>
               <v-card>
                  <v-card-title class="headline grey lighten-1">
                     {{ $t('titles.settings_spf_dkim') }}
                  </v-card-title>
                  <v-card-text>
                     <h2>{{ $t('titles._spf_full_settings') }}</h2>
                        <p v-html="$t('messages._spf_full_settings_1')"></p>
                        <p v-html="$t('messages._spf_full_settings_2')"></p>
                        <p v-html="$t('messages._spf_full_settings_3')"></p>
                        <p v-html="$t('messages._spf_full_settings_4')"></p>
                     <h2>{{ $t('titles._dkim_full_settings') }}</h2>
                        <p v-html="$t('messages._dkim_full_settings_1')"></p>
                        <p v-html="$t('messages._dkim_full_settings_2')"></p>
                        <p v-html="$t('messages._dkim_full_settings_3')"></p>
                        <p v-html="$t('messages._dkim_full_settings_4')"></p>

                     <ddoClientList :loading="loading" :level="levels[1]" :childKey="levels[1].childKey"
                        :columns="levels[1].columns"
                        :options="levels[1].options" 
                        :callbacks="levels[1].callbacks" 
                        :customSlotNames="levels[1].customSlotNames" 
                        @row="refresh_row"
                        name="myDKIMList" 
                        ref="myDKIMList"
                     >

                        <template v-slot:superheader="{ errors }">
                           <h3>{{ $t('titles.dkr') }}</h3>
                        </template>

                        <template slot="searchengine" slot-scope="props">
                           <br/><br/>
                           <ddoAlert :errors="dkim_errors"/>
                        </template>

                        <template v-slot:dialogform="{ row, level }">
                           <CardUpdatableDKIMDomain ref="myCardDKIMDomain" :row="levels[1].row" :depth="levels[1].level" :level="levels[1]"
                              @errors="refresh_errors"
                              @change_dialogValues="change_dialogValues"
                           />
                        </template>

                        <template slot="_create" slot-scope="props">
                           <slot name="_create" v-scope="props">
                              <p>{{ $api._d(props.row._create,'short') }}</p>
                           </slot>
                        </template>

                        <template slot="dkr_selector" slot-scope="props">
                           {{ props.row.dkr_selector }}._domainkey
                        </template>

                        <template slot="dkr_publickey" slot-scope="props">
                           <v-tooltip top v-if="props.row.dkr_validated">
                              <template v-slot:activator="{ on }">
                                 <span v-on="on">
                                    <v-btn fab small><v-icon x-large color="green darken-2">mdi-alert-circle-check</v-icon></v-btn>
                                 </span>
                              </template>
                              <span>{{ $t('tooltips.dns_validated') }}</span>
                           </v-tooltip>
                           <v-tooltip top v-else>
                              <template v-slot:activator="{ on }">
                                 <span v-on="on">
                                    <v-btn fab small><v-icon x-large color="red darken-2">mdi-alert-circle</v-icon></v-btn>
                                 </span>
                              </template>
                              <span>{{ $t('tooltips.dns_not_validated') }}</span>
                           </v-tooltip>
                           {{ shorten_publickey(props.row.dkr_publickey) }}
                           <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                 <span v-on="on">
                                    <v-btn fab small @click="copy_to_clipboard_txt_record(props.row)"><v-icon>mdi-content-copy</v-icon></v-btn>
                                 </span>
                              </template>
                              <span>{{ $t('tooltips.clipboard') }}</span>
                           </v-tooltip>
                           <span v-if="!props.row.dkr_validated">
                              <br/>
                              <span v-if="props.row.dkr_lastcheck_at!=null">{{ $t('texts.dkim_last_check') }} : {{ $api._d(props.row.dkr_lastcheck_at,'timestamp1','fr') }}</span>&nbsp;<v-btn @click="check_dns_record(props.row)" class="primary" rounded>{{ $t('buttons.check_dns_and_validate') }}</v-btn>
                           </span>
                        </template>

                     </ddoClientList>
                  </v-card-text>
               </v-card>

               <v-dialog name="CopytoClipboard" v-model="subdialogShow" data-app="true" persistent max-width="800">
                  <v-card>
                     <v-card-title>
                        <span class="headline">{{ $t('titles._dns_record_to_create') }}</span>
                     </v-card-title>
                     <v-card-text>
                        <input type="hidden" name="keytocopy" id="keytocopy" :value='dns_record.value'>
                        <slot name="content">
                           <p v-html="format_dns_explanation()"></p>
                           <strong><pre>{{ dns_record.value }}</pre></strong>
                           <p v-html="$t('messages._dkim_record_explanation_2')"></p>
                        </slot>
                     </v-card-text>
                     <v-card-actions>
                        <div class="flex-grow-1"></div>
                        <v-btn small class="primary" rounded @click="subdialogShow=false">{{ $t('buttons.ok') }}</v-btn>
                     </v-card-actions>
                  </v-card>
               </v-dialog>

            </b-tab>

         </b-tabs>
      </b-card>

    </div>
  </v-app>
</template>

<script>
import Vue from 'vue';
import i18n from '@/plugins/i18n.js';
import util from 'util';
import BasicComponent from '@/views/BasicComponent.vue';
import ddoAlert from '@/components/ddoAlert.vue';
import ddoWaiting from '@/components/ddoWaiting.vue'
import TileSimple from '@/components/partials/TileSimple.vue';
import TileSimpleSMTPPRO from '@/components/partials/TileSimpleSMTPPRO.vue';
import ddoSelectSwitchCustomer from '@/components/ddoSelectSwitchCustomer.vue'
import ddoSelect2 from '@/components/ddoSelect2.vue';
import ddoGraphBar from '@/components/ddoGraphBar.vue';
import ddoGraphPie from '@/components/ddoGraphPie.vue';
import ddoClientList from '@/components/ddoClientList.vue';
import CardUpdatableDKIMDomain from '@/components/partials/CardUpdatableDKIMDomain.vue';

var vsprintf = require('sprintf-js').vsprintf;

export default {
   name: 'customerresellerservicesmtppro',
   mixins: [BasicComponent],
   components: {
      ddoAlert,
      ddoWaiting,
      ddoSelectSwitchCustomer, 
      ddoSelect2,
      TileSimple,
      TileSimpleSMTPPRO,
      ddoGraphBar,
      ddoGraphPie,
      ddoClientList,
      CardUpdatableDKIMDomain,
   },
   data: () => {
      return {
         accounts : {
            count: null,
            rows: [],
            current_type: null,
            current_data: null,
            current_account: 'null',
            per_status: false,
         },

         subdialogShow: false,
         dns_record: {
            value: null,
            domain: null,
            selector: null,
            key: null,
         },
         dns_records_count: 0,
         dkim_errors: [],

         subdialogExplanation: '',

         session_row: {},

         ws_code: 'service',
         ws_key: 'SMTP-PRO-SERVICE',
         ws_stats_keyword: 'stats',
         ws_search_code: 'service_smtppro',
         ws_search_keyword: 'search',
         ws_export_keyword: 'export',
         ws_report_type: 'month',

         loading: false,
         searching: false,
         loaded_standard: false,
         loaded_per_status: false,
         height: 250,
         rows: [],
         bgcolors: [],
         charts: [],
         data: [ null, null, null, null ], // month/month_cum, last30day, last12month, per_status
         PIEoptions: {
            responsive: true,
         },
         ZOOMoptions: {
            legend: {
               display: true,
            },
            title: {
               display: false,
               text: ''
            },
            scales: {
               xAxes: [ {
                  display: true,
                  stacked: true,
               }],
               yAxes: [ {
                  display: true,
                  stacked: true,
               }]
            },
            plugins: {
               datalabels: {
                  anchor: 'end',
                  align: 'top',
                  formatter: Math.round,
                  font: {
                     weight: 'bold'
                  }
               }
            }
         },

         showSearchDialog: false,
         showMessageDetail: false,
         current_messageid: null,

         boolFormValid: false,
         search_radix_from: null,
         search_domain_from: null,
         search_radix_to: null,
         search_domain_to: null,
         dates: new Date().toISOString().substr(0, 10),

         dropdown_graph_text: i18n.t('texts.choose_dropdown_graph'),
         dropdown_graph_account: i18n.t('texts.choose_dropdown_account'),
         search_results: [],
         search_headers: [
            { text: i18n.t('headers.datetime'), value: 'd_smtp_log_event', width: "200px" },
            { text: i18n.t('headers.messageid'), value: 'c_smtp_log_messageid' },
            { text: i18n.t('headers.servername'), value: 'c_smtp_log_server' },
            { text: i18n.t('headers.sendername'), value: 'c_smtp_log_sender' },
            { text: i18n.t('headers.recipient'), value: 'c_smtp_log_recipient' },
            { text: i18n.t('headers.comments'), value: 'comments' },
         ],

         message_results: [],
         message_headers: [
            { text: i18n.t('headers.datetime'), value: 'd_smtp_log_event', width: "200px", fixed: true },
            { text: i18n.t('headers.servername'), value: 'c_smtp_log_server' },
            { text: i18n.t('headers.traces'), value: 'c_smtp_log_comments' },
         ],

         search_errors: [],
         message_errors: [],

         /* 
         LEVEL 0 : all for ddoClientList : columns, options, callbacks
         */
         levels: [
            {
               api_code: 'service_smtppro',
               api_prefix: 'prl',
               row: {},
               level: 0,
               errors: [],
               columns: ['c_smtp_log_day','c_smtp_log_key', 'status_sent', 'status_bounced', 'status_expired', 'status_deferred', 'n_smtp_log_avg', 'status_graph' ],
               customSlotNames: ['c_smtp_log_day', 'status_sent', 'status_bounced', 'status_expired', 'status_deferred', 'n_smtp_log_avg', 'status_graph' ],
               searchValues: {
               },
               options: {
                  showChildRowToggler: false,
                  hiddenColumns: [],
                  headings: {
                     c_smtp_log_day: i18n.t('headers.synthesis_date'),
                     c_smtp_log_key: i18n.t('headers.synthesis_account'),
                     status_sent: i18n.t('headers.synthesis_sent'),
                     n_smtp_log_avg: i18n.t('headers.deliverance_average_time'),
                     status_bounced: i18n.t('headers.synthesis_bounced'),
                     status_expired: i18n.t('headers.synthesis_expired'),
                     status_deferred: i18n.t('headers.synthesis_deferred'),
                     status_graph: i18n.t('headers.synthesis_graph'),
                  },
                  texts: {
                  },
                  uniqueKey: 'prl_pk',
                  sortable: ['cus_code','_update'],
                  filterable: false,
                  sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
                  columnsDropdown: false,
                  pagination: {
                     chunk: 5,
                     edge: false,
                     nav: 'scroll'
                  },
                  columnsDisplay: {
                     _update: 'desktop',
                     cus_code: 'desktop',
                     cus_pk: 'desktop',
                  },
                  customFilters: [{
                     name: 'search',
                     callback: function (row, query) {
                        let $ret = true;
                        return $ret;
                     }
                  }],
               },
               callbacks: {
               },
               dialogOptions: {
                  codeRules : [
                     (v) => !!v || i18n.t('texts._required')
                  ]
               },
               dialogValues: {
                  headers: {
                     select: i18n.t('texts.cus_select_title'),
                     create: i18n.t('texts.cus_create_title'),
                     update: i18n.t('texts.cus_update_title'),
                     delete: i18n.t('texts.cus_delete_title'),
                  },
                  texts: {
                     create_item: i18n.t('texts.cus_create_item'),
                  },
                  dialogShow: false,
                  form_disabled: false,
                  form_close: true,
                  form_create: false,
                  form_update: false,
                  form_delete: false,
                  readonly: false,
                  header_value_function: function(row) { return row['cus_code']; }
               },
            },

            {
               api_code: 'dkimrequest',
               api_prefix: 'dkr',
               row: {},
               level: 1,
               errors: [],
               columns: ['_actions','dkr_domainname', 'dkr_selector', 'dkr_publickey' ],
               customSlotNames: ['dkr_selector','dkr_publickey'],
               searchValues: {
               },
               options: {
                  showChildRowToggler: false,
                  hiddenColumns: [],
                  withUpdate: false,
                  withDelete: true,
                  headings: {
                     dkr_domainname: i18n.t('headers.dkr_domainname'),
                     dkr_publickey: i18n.t('headers.dkr_publickey'),
                     dkr_selector: "ID",
                  },
                  texts: {
                  },
                  uniqueKey: 'dkr_pk',
                  sortable: [],
                  filterable: false,
                  sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
                  columnsDropdown: false,
                  pagination: {
                     chunk: 5,
                     edge: false,
                     nav: 'scroll'
                  },
                  columnsDisplay: {
                     _update: 'desktop',
                     cus_code: 'desktop',
                     cus_pk: 'desktop',
                  },
                  customFilters: [{
                     name: 'search',
                     callback: function (row, query) {
                        let $ret = true;
                        return $ret;
                     }
                  }],
               },
               callbacks: {
               },
               dialogOptions: {
                  codeRules : [
                     (v) => !!v || i18n.t('texts._required')
                  ],
                  domainnameRules : [
                     (v) => !v || /^\w+([.-]?\w+)*(\.\w{2,24})+$/.test(v) || i18n.t('texts._domainname_format'),
                  ],
               },
               dialogValues: {
                  headers: {
                     select: i18n.t('texts.dkr_select_title'),
                     create: i18n.t('texts.dkr_declare_title'),
                     update: i18n.t('texts.dkr_update_title'),
                     delete: i18n.t('texts.dkr_delete_title'),
                  },
                  texts: {
                     create_item: i18n.t('texts.dkr_declare_item'),
                  },
                  dialogShow: false,
                  form_disabled: false,
                  form_close: true,
                  form_create: false,
                  form_update: false,
                  form_delete: false,
                  disable_create: true,
                  disable_update: false,
                  disable_delete: false,
                  readonly: false,
                  header_value_function: function(row) { return row['dkr_domainname']; }
               },
            },
         ],

         PLFcallbacks: {},
         PLFoptions: {
            initial: null,
            selected: null,
            required: true,
            disabled: false,
            multiple: false,
            clearable: false,
            rules: [
               (v) => !!v || i18n.t('texts._required')
            ],
            item_text: "xxx_sasl_usernames",
            item_value: "_pk",
            item_disabled: "",
            hide_selected: false,
            label: i18n.t('texts.search_xxx_sasl_usernames'),
            hint: i18n.t('hints.search_xxx_sasl_usernames'),
         },

         STATUScallbacks: {},
         STATUSoptions: {
            initial: null,
            selected: null,
            required: true,
            disabled: false,
            multiple: false,
            clearable: false,
            item_text: "status_label",
            item_value: "_pk",
            item_disabled: "",
            hide_selected: false,
         },

         ACCOUNTcallbacks: {},
         ACCOUNToptions: {
            initial: null,
            selected: null,
            required: true,
            disabled: false,
            multiple: false,
            clearable: false,
            item_text: "status_label",
            item_value: "_pk",
            item_disabled: "",
            hide_selected: false,
         },

         GRAPHcallbacks: {},
         GRAPHoptions: {
            initial: null,
            selected: null,
            required: true,
            disabled: false,
            multiple: false,
            clearable: false,
            item_text: "value",
            item_value: "_pk",
            item_disabled: "",
            hide_selected: false,
         },

         dropdown_graph_text: i18n.t('texts.choose_dropdown_graph'),
         dropdown_graph_account: i18n.t('texts.choose_dropdown_account'),

         locale: null,

         options: [],
         data_type: 'mails',

         current_unit: ' ?',
   
      }
   },

   created() {
      this._this = this;
      var empty_chart = { value: null, unit: '', total_bytes: 0, total_messages: 0, message: '', labels: [], severity: [], date: [], data: [], reference: [], chartdata: { labels: [], datasets: [] }, options: {} };

      for( var i=0;i<=8;i++ ) {
         this.charts.push( JSON.parse(JSON.stringify(empty_chart)) );
      }

      this.levels[0].callbacks.refresh_rows   = this.refresh_rows_l1;

      this.levels[1].callbacks.refresh_rows   = this.refresh_rows_l2;
      this.levels[1].callbacks.configure_form = this.configure_form;
      this.levels[1].callbacks.show_dialog    = this.show_dialog;
      this.levels[1].callbacks.prepare_create = this.prepare_create_l2;
      this.levels[1].callbacks.create_row     = this.create_row_l2;

      var style = getComputedStyle(document.body);
   },

   async mounted() {
      var style = getComputedStyle(document.body);
      this.bgcolors[0] = style.getPropertyValue('--success');
      this.bgcolors[1] = style.getPropertyValue('--warning');
      this.bgcolors[2] = style.getPropertyValue('--danger');
      this.bgcolors[3] = style.getPropertyValue('--secondary');

      this.PLFcallbacks.refresh_rows = this.build_select_plf;
      this.PLFcallbacks.change       = this.change_plf;

      this.GRAPHcallbacks.refresh_rows = this.build_select_graphtype;
      this.GRAPHcallbacks.change       = this.change_graphtype;

      this.STATUScallbacks.refresh_rows  = this.build_select_status;

      this.ACCOUNTcallbacks.refresh_rows = this.build_select_plf;
      this.ACCOUNTcallbacks.change       = this.change_plf;

      //await this.refresh_session();
      await this.refresh_page();
      
      this.locale = navigator.language;
    },

   computed: {
      datesFormatted () {
         if ( Array.isArray(this.dates) ) {
            if ( this.dates.length==2 && this.dates[0]>this.dates[1] ) {
               let tmp = this.dates[0];
               this.dates[0] = this.dates[1];
               this.dates[1] = tmp;
            }
            return this.dates.join(' ~ ')
         } else {
            return this.dates
         }
      },

      exportButtonText () {
         let current_date = null;
         if ( Array.isArray(this.dates) ) {
            current_date = this.dates[0];
         } else {
            current_date = this.dates;
         }
         if ( this.STATUSoptions.selected!=null ) {
            return util.format(i18n.t('buttons.export_month_csv_with_status'),this.STATUSoptions.selected,this.$api._d(current_date,'monthly',this.locale));
         } else {
            return util.format(i18n.t('buttons.export_month_csv'),this.$api._d(current_date,'monthly',this.locale));
         }
      },

      isFormValid: {
         get: function() {
            return this.boolFormValid;
         },
         set: function(newValue) {
            this.boolFormValid = newValue;
         }
      },

   },

   methods: {

      zero_if_null(value) {
         if ( value==null ) {
            return 0
         } else {
            return value
         }
      },

      shorten_servername(name) {
         return ( name!=null ? name.split('.')[0] : '' )
      },

      shorten_publickey(name) {
         return ( name!=null ? name.substring(0,50)+'...' : '' )
      },

      format_dns_explanation() {
         return vsprintf(i18n.t('messages._dkim_record_explanation_1'),[this.dns_record.domain,this.dns_record.key])
      },

      copy_to_clipboard_txt_record(row) {
         this.subdialogShow = true;
         this.dns_record = { value: '"v=DKIM1; k=rsa; p='+row.dkr_publickey+'"', domain: row.dkr_domainname, selector: row.dkr_selector, key: row.dkr_key };
         navigator.clipboard.writeText(this.dns_record.value);
      },

      buildRef(row) {
         return '_pie_graph_'+row._pk;
      },

      PIEchartdata(row) {
         //console.log('PIEchartdata, row='+JSON.stringify(row))
         if ( row.c_smtp_log_day ) {
            return {
               datasets: [
                  {
                     backgroundColor: [ 'green', 'red', 'orange' ],
                     data: [ this.zero_if_null(row.status_sent), this.zero_if_null(row.status_bounced)+this.zero_if_null(row.status_expired), this.zero_if_null(row.status_deferred) ]
                  },
               ]
            }
         } else {
            return { datasets: [] }
         }
      },
      
      async refresh_rows_l1(key) {
         var row_plf = this.$api._get_by_pk(this.$refs.myPLFSelect1.items,this.PLFoptions.selected);
         var day_to   = new Date().toISOString().substr(0, 10);
         var day_from   = new Date( Date.now() - 1000 * 86400 * 13 ).toISOString().substr(0, 10);
               
         if ( row_plf!=null ) {
            let parameters = { log_direction: 'O', log_sasl_username: row_plf.xxx_sasl_usernames, log_day_from: day_from, log_day_to: day_to, log_count_per_day: true };
            this.loading = true;
            let { errorinfos, api_response } = await this.$api.getRows( this.$router, this.ws_search_code+'/'+this.ws_key+'/'+this.ws_search_keyword, parameters ); 
            this.loading = false; 
            if ( api_response.error==0 && api_response.rows ) {
               for ( var i=0;i<api_response.rows.length;i++ ) {
                  api_response.rows[i]._pk = i+1;
               }
            }      
            return { errorinfos, api_response }
         } else {
            return { errorinfos : null, api_response: {error: 0, rows: []} }
         }
      },

      async refresh_rows_l2(key) {
         this.loading = true;
         this.loading = true;
         await this.refresh_session();
         let { errorinfos, api_response } = await this.$api.getRows(this.$router,'customer'+'/'+this.session_row.cus_pk_customer+'/dkimrequests');
         if ( api_response.error==0 && api_response.rows ) {
            this.dns_records_count = api_response.rows.length;
         }
         this.loading = false;
         return { errorinfos, api_response }
      },

      async openSearchDialog() {
         if ( this.$refs.myPLFSelect ) {
            await this.$refs.myPLFSelect.refresh_rows();
         }
         this.search_errors = [];
         this.search_results = [];
         this.showSearchDialog = true;
      },

       getAllowedDates (val) {
          var now = new Date().toISOString().substr(0, 10);
         
          if (val <= now) {
             return true
          } else {
             return false
          }
       },

      LightenDarkenColor(col,amt) {
         col = col.trim();
         var usePound = false;
         if ( col.substring(0,1) == "#" ) {
            col = col.substring(1);
            usePound = true;
         }
         var num = parseInt(col,16);
         var r = (num >> 16) + amt;

         if ( r > 255 ) r = 255;
         else if  (r < 0) r = 0;

         var b = ((num >> 8) & 0x00FF) + amt;

         if ( b > 255 ) b = 255;
         else if  (b < 0) b = 0;

         var g = (num & 0x0000FF) + amt;

         if ( g > 255 ) g = 255;
         else if  ( g < 0 ) g = 0;

         return (usePound?"#":"") + (g | (b << 8) | (r << 16)).toString(16);
      },

      get_max(data,_min=0) {
         var _max = _min;
         for( var i=0;i<data.length;i++ ) {
            if ( data[i]>_max ) { _max = data[i]; }
         }
         return _max;
      },

      compute_currentmonth(data) {
         if (data[0] && data[0].prl_day) {
            var _date = new Date(data[0].prl_day);
         } else {
            var _date = new Date(data[0].prl_day);
         }
         var _month = _date.getMonth();
         return _month;
      },

      build_labels(report_type,data,length) {
         var labels = [];
         var _format = 'short';
         if ( report_type=='last12months' ) {
            _format = 'monthly';
         }
         for (var i=0;i<data.length;i++) {
            labels.push( this.$api._d(data[i],_format) );
         }
         if ( labels.length<length && ( report_type=='month' || report_type=='month_cum' ) ) {
            for (var i=labels.length;i<length;i++) {
               labels.push( '' );
            }
         }
         return labels;
      },

      build_bgcolors(report_type,data,length) {
         var bgcolors = [];
         for (var i=0;i<data.length;i++) {
            bgcolors.push( this.bgcolors[data[i]] );
         }
         if ( bgcolors.length<length && ( report_type=='month' || report_type=='month_cum' ) ) {
            for (var i=bgcolors.length;i<length;i++) {
               bgcolors.push( '' );
            }
         }
         return bgcolors;
      },

      build_bgcolors_v2(report_type,data,length,percent) {
         var bgcolors = [];
         for (var i=0;i<data.length;i++) {
            bgcolors.push( this.LightenDarkenColor(this.bgcolors[data[i]], percent) );
         }
         if ( bgcolors.length<length && ( report_type=='month' || report_type=='month_cum' ) ) {
            for (var i=bgcolors.length;i<length;i++) {
               bgcolors.push( '' );
            }
         }
         return bgcolors;
      },

      build_bgcolors_per_status(report_type,data,length,percent) {
         var bgcolors = [];
         for (var i=0;i<data.length;i++) {
            bgcolors.push( this.LightenDarkenColor(this.bgcolors[this.bgcolors.length-1], percent) );
         }
         if ( bgcolors.length<length && ( report_type=='month' || report_type=='month_cum' ) ) {
            for (var i=bgcolors.length;i<length;i++) {
               bgcolors.push( '' );
            }
         }
         return bgcolors;
      },

      build_options_standard(data) {
         var options = {
            legend: {
               display: false,
            },
            scales: {
               xAxes: [ {
                  display: false,
               }],
               yAxes: [ {
                  display: false,
                  ticks: {
                     min: 0,
                     max: this.get_max(data),
                  }
               }]
            }
         };
         return options;
      },

      build_options(report_type,data) {
         var options = {
            legend: {
               display: false,
            },
            scales: {
               xAxes: [ {
                  display: false,
                  stacked: true,
               }],
               yAxes: [ {
                  display: false,
                  stacked: true,
                  ticks: {
                     min: 0,
                     max: this.get_max(data),
                  }
               }]
            }
         };
         return options;
      },

      build_accounts_list(rows) {
         this.accounts.count = rows.length;
         this.accounts.rows = [];
         if ( this.accounts.count>1 ) {
            this.accounts.rows.push( { _pk: -1, code: 'null', name: '*' } );
         }
         for (var j=0;j<rows.length;j++) {
            this.accounts.rows.push( { _pk: j+1, code: rows[j].prl_sub_key_1, name: rows[j].prl_sub_key_1 } );
         }
      },

      prepare_chart_data_standard(values,rows,report_type,data_type) {
         values.date = [];
         values.severity = [];
         values.data = [];
         values.total_messages = 0;
         values.total_bytes = 0;
         var current_date = new Date();
         current_date = current_date.toISOString().substr(0,10);

         var bytes_cum = 0;

         for ( var i=0; i<rows.length; i++ ) {

            if ( rows[i].prl_day<=current_date ) {
               values.total_messages = values.total_messages+parseInt(rows[i].prl_count1);
               values.total_bytes = values.total_bytes+parseInt(rows[i].prl_count2);
               values.date.push(rows[i].prl_day);
               values.severity.push(rows[i].esv_severity);
            }

            switch ( report_type ) {
               case 'month_cum' : {
                  switch( data_type ) {
                     case 'mails' : {
                        if ( i > 0 && rows[i].prl_day<=current_date ) {
                           values.data.push(parseInt(rows[i].prl_count1)+values.data[values.data.length-1])
                        } else {
                           values.data.push(parseInt(rows[i].prl_count1))
                        }
                        break;
                     }
                     case 'bytes' : {
                        if ( i > 0 && rows[i].prl_day<=current_date ) {
                           bytes_cum = bytes_cum + parseInt(rows[i].prl_count2);
                        } else {
                           bytes_cum = parseInt(rows[i].prl_count2);
                        }
                        values.data.push(Math.round( this.$api._format_bytes(bytes_cum,'mega',false)))
                        break;
                     }
                  }
                  break;
               }
               default : {
                  switch( data_type ) {
                     case 'mails' : {
                        values.data.push(parseInt(rows[i].prl_count1))
                        break;
                     }
                     case 'bytes' : {
                        values.data.push(Math.round( this.$api._format_bytes(parseInt(rows[i].prl_count2),'mega',false)))
                        break;
                     }
                  }
               }
            } 
         } 

         var dataset_label = '';

         switch ( data_type ) {

            case 'mails':
               values.value = values.total_messages;
               values.unit = i18n.t('texts._emails').toLowerCase();
               switch( report_type ) {
                  case 'month'        : values.message = i18n.t('texts.smtppro_mails_month_short'); break;
                  case 'month_cum'    : values.message = i18n.t('texts.smtppro_mails_month_cumulative_short'); break;
                  case 'last30'       : values.message = i18n.t('texts.smtppro_mails_last30_short'); break;
                  case 'last12months' : values.message = i18n.t('texts.smtppro_mails_last12months_short'); break;
               }
               break;

            case 'bytes':
               values.value = parseInt(this.$api._format_bytes(values.total_bytes,'mega',false));
               values.unit = i18n.t('utils.megabytes');
               switch( report_type ) {
                  case 'month'        : values.message = i18n.t('texts.smtppro_bytes_month_short'); break;
                  case 'month_cum'    : values.message = i18n.t('texts.smtppro_bytes_month_cumulative_short'); break;
                  case 'last30'       : values.message = i18n.t('texts.smtppro_bytes_last30_short'); break;
                  case 'last12months' : values.message = i18n.t('texts.smtppro_bytes_last12months_short'); break;
               }
               break;
         }

         if ( this.accounts.current_account && this.accounts.current_account!='null' ) {
            dataset_label  = dataset_label + ' (' + this.accounts.current_account + ')';
         }

         var _nb_of_rows = 31;
         if ( report_type=='last12months') {
            _nb_of_rows = 12;
         }

         values.values = values.data;
         values.options = this.build_options_standard(values.data);
         values.chartdata = {
            labels : this.build_labels(report_type,values.date,_nb_of_rows),
            datasets: [
               {
                  label: 'total',
                  backgroundColor: this.build_bgcolors(report_type,values.severity,_nb_of_rows),
                  data: values.data
               },
            ]
         };
         
      },

      prepare_chart_data_per_status( values, rows, report_type, data_type ) {
         var statuses = [ 'sent', 'bounced', 'expired', 'deferred' ];

         values.date = [];
         values.severity = [];
         values.data = [];
         values.total_messages = 0;
         values.total_bytes = 0;

         var _nb_of_rows = 31;
         if ( report_type == 'last12months') {
            _nb_of_rows = 12;
         }

         values.chartdata = {
            datasets: [
               { label: i18n.t('texts.smtppro_mails_sent')    , backgroundColor: '', borderColor: '#000000', borderWidth: 1, borderStyle: 'solid', data: [] }, 
               { label: i18n.t('texts.smtppro_mails_bounced') , backgroundColor: '', borderColor: '#000000', borderWidth: 1, borderStyle: 'solid', data: [] }, 
               { label: i18n.t('texts.smtppro_mails_expired') , backgroundColor: '', borderColor: '#000000', borderWidth: 1, borderStyle: 'solid', data: [] }, 
               { label: i18n.t('texts.smtppro_mails_deferred'), backgroundColor: '', borderColor: '#000000', borderWidth: 1, borderStyle: 'solid', data: [] } 
            ]
         };

         var bytes_cum = [ 0, 0, 0, 0 ];

         for ( var i=0; i<rows.length; i++ ) {

            // Pre-fill values[...][0], for month_cum
            if ( i==0 ) {
               for ( var k=0;k<statuses.length;k++ ) {
                  values.chartdata.datasets[k].data[i] = 0;
               }
            }

            values.total_messages = values.total_messages+parseInt(rows[i].prl_count1);
            values.total_bytes = values.total_bytes+parseInt(rows[i].prl_count2);
            values.date.push(rows[i].prl_day);
            values.severity.push(rows[i].esv_severity);

            let key1 = null;
            let key2 = null;
            let keys = null;
            keys = Object.keys(rows[i]['prl_values']);
            for ( var k=0;k<keys.length;k++ ) {
               key1 = keys[k];
               key2 = key1;
               // key1 ; original key value
               // key2 : copy of key1, except when key1='total' and 'no_detail'; if this case => key2 = 'sent'
               if ( rows[i]['prl_no_detail'] && rows[i]['prl_no_detail']==true && key1=='total' ) {
                  key2 = 'sent';
               }
               if ( statuses.indexOf(key2)>=0 ) {
                  switch (report_type) {
                     case 'month_cum':
                        switch( data_type ) {
                           case 'mails' :
                              if ( i>0 ) {
                                 values.chartdata.datasets[statuses.indexOf(key2)].data[i] = parseInt(rows[i]['prl_values'][key1].prl_count1) + values.chartdata.datasets[statuses.indexOf(key2)].data[i-1];
                              } else {
                                 values.chartdata.datasets[statuses.indexOf(key2)].data[i] = parseInt(rows[i]['prl_values'][key1].prl_count1);
                              }
                              break;
                           case 'bytes' :
                              if ( i>0 ) {
                                 bytes_cum[statuses.indexOf(key2)] = bytes_cum[statuses.indexOf(key2)] + parseInt(rows[i]['prl_values'][key1].prl_count2);
                              } else {
                                 bytes_cum[statuses.indexOf(key2)] = parseInt(rows[i]['prl_values'][key1].prl_count2);
                              }
                              values.chartdata.datasets[statuses.indexOf(key2)].data[i] = Math.round( this.$api._format_bytes(bytes_cum[statuses.indexOf(key2)],'mega',false));
                              break;
                        }
                        break;
                     default:
                        switch( data_type ) {
                           case 'mails' :
                              values.chartdata.datasets[statuses.indexOf(key2)].data[i] = parseInt(rows[i]['prl_values'][key1].prl_count1);
                              break;
                           case 'bytes' :
                              values.chartdata.datasets[statuses.indexOf(key2)].data[i] = Math.round( this.$api._format_bytes(parseInt(rows[i]['prl_values'][key1].prl_count2),'mega',false));
                              break;
                        }
                        break;
                  }
               }
            }

         }
         
         values.chartdata.datasets[statuses.indexOf('sent')    ].backgroundColor = this.build_bgcolors_per_status('month',values.severity,31,  0);
         values.chartdata.datasets[statuses.indexOf('bounced') ].backgroundColor = this.build_bgcolors_per_status('month',values.severity,31,-20);
         values.chartdata.datasets[statuses.indexOf('expired') ].backgroundColor = this.build_bgcolors_per_status('month',values.severity,31,-30);
         values.chartdata.datasets[statuses.indexOf('deferred')].backgroundColor = this.build_bgcolors_per_status('month',values.severity,31,-40);

         var dataset_label = '';

         switch ( data_type ) {

            case 'mails':
               values.value = values.total_messages;
               values.unit = i18n.t('texts._emails').toLowerCase();
               switch( report_type ) {
                  case 'month'        : values.message = i18n.t('texts.smtppro_mails_month_short'); break;
                  case 'month_cum'    : values.message = i18n.t('texts.smtppro_mails_month_cumulative_short'); break;
                  case 'last30'       : values.message = i18n.t('texts.smtppro_mails_last30_short'); break;
                  case 'last12months' : values.message = i18n.t('texts.smtppro_mails_last12months_short'); break;
               }
               break;

            case 'bytes':
               values.value = parseInt(this.$api._format_bytes(values.total_bytes,'mega',false));
               values.unit = i18n.t('utils.megabytes');
               switch( report_type ) {
                  case 'month'        : values.message = i18n.t('texts.smtppro_bytes_month_short'); break;
                  case 'month_cum'    : values.message = i18n.t('texts.smtppro_bytes_month_cumulative_short'); break;
                  case 'last30'       : values.message = i18n.t('texts.smtppro_bytes_last30_short'); break;
                  case 'last12months' : values.message = i18n.t('texts.smtppro_bytes_last12months_short'); break;
               }
               break;
         }

         if ( this.accounts.current_account && this.accounts.current_account!='null' ) {
            dataset_label  = dataset_label + ' (' + this.accounts.current_account + ')';
         }

         values.values = values.data;
         values.chartdata.labels = this.build_labels(report_type,values.date,_nb_of_rows);

         // Adapt title :
         this.ZOOMoptions.title.display = true;
         this.ZOOMoptions.title.text = values.unit+" "+values.message;
      },

      retrieve_row_by_date(rows,date,lastindex) {
         for ( var j=lastindex;j<rows.length;j++) {
            if (rows[j].prl_day && rows[j].prl_day==date) {
               return j;
            }
         }
         return null;
      },

      restructure_monthly_records(report_type,rows) {
         var current_date = new Date();
         var empty_row = { prl_major_key: null, prl_day: null, prl_count0: 0, prl_count1: 0, prl_count2: 0, esv_severity:0 }
         var restructured_rows = [];
         var lastindex = 0;
         var currentindex = 0;
         switch ( report_type ) {
            case 'month':
            case 'month_cum':
               var start_date = current_date;
               start_date.setDate(1);
               for ( var i=0;i<31;i++) {
                  let current_row = JSON.parse(JSON.stringify(empty_row));
                  currentindex = this.retrieve_row_by_date(rows,start_date.toISOString().substr(0, 10),lastindex);
                  if ( currentindex!=null ) { current_row = rows[currentindex]; }
                  restructured_rows.push(JSON.parse(JSON.stringify(current_row)));
                  start_date.setDate(start_date.getDate()+1);
               }
               return restructured_rows;
               break;
            case 'last30':
               var start_date = current_date;
               start_date.setDate(start_date.getDate()-30);
               for ( var i=0;i<31;i++) {
                  let current_row = JSON.parse(JSON.stringify(empty_row));
                  currentindex = this.retrieve_row_by_date(rows,start_date.toISOString().substr(0, 10),lastindex);
                  if ( currentindex!=null ) { current_row = rows[currentindex]; }
                  restructured_rows.push(JSON.parse(JSON.stringify(current_row)));
                  start_date.setDate(start_date.getDate()+1);
               }
               return restructured_rows;
               break;
            default:
               return rows;
               break;
         }
      },

      async refresh_data_standard(report_type,force_all=false) {
         let parameters = { plf_report_type: report_type, plf_per_status: false };
         let { errorinfos, api_response } = await this.$api.getRows( this.$router, this.ws_search_code+'/'+this.ws_key+'/'+this.ws_stats_keyword, parameters );
         //console.log('refresh_data_standard, api_response='+JSON.stringify(api_response))
         if ( api_response.error==0 ) {
            return this.restructure_monthly_records(report_type,api_response.rows);
         } else {
            return null;
         }
      },

      async refresh_data_per_status(report_type,force_all=false) {
         let parameters = { plf_report_type: report_type, plf_per_status: true };
         if ( this.ACCOUNToptions.selected!=null) {
            let row_account = this.$api._get_by_pk(this.$refs.myACCOUNTSelect.items,this.ACCOUNToptions.selected);
            parameters.plf_report_account = row_account.xxx_sasl_usernames;
         }
         let { errorinfos, api_response } = await this.$api.getRows( this.$router, this.ws_search_code+'/'+this.ws_key+'/'+this.ws_stats_keyword, parameters );
         if ( api_response.error==0 ) {
            return api_response.rows;
         } else {
            return null;
         }
      },

      async refresh_accounts() {
         let { errorinfos, api_response } = await this.$api.getRows( this.$router, this.ws_search_code+'/'+this.ws_key+'/accounts' );
         if ( api_response.error==0 ) {
            this.build_accounts_list(api_response.rows);
         }
      },

      async refresh_data() {

         this.loaded_standard = false;
         this.loaded_per_status = false;

         await this.refresh_accounts();

         this.data[0] = await this.refresh_data_standard( 'month' );
         this.data[1] = await this.refresh_data_standard( 'month_cum' );
         this.data[2] = await this.refresh_data_standard( 'last30' );
         this.data[3] = await this.refresh_data_standard( 'last12months' );

         this.prepare_chart_data_standard( this.charts[0],this.data[0],'month','mails',false );
         this.prepare_chart_data_standard( this.charts[1],this.data[1],'month_cum','mails',false );
         this.prepare_chart_data_standard( this.charts[2],this.data[2],'last30','mails',false );
         this.prepare_chart_data_standard( this.charts[3],this.data[3],'last12months','mails',false );
         this.prepare_chart_data_standard( this.charts[4],this.data[0],'month','bytes',false );
         this.prepare_chart_data_standard( this.charts[5],this.data[1],'month_cum','bytes',false );
         this.prepare_chart_data_standard( this.charts[6],this.data[2],'last30','bytes',false );
         this.prepare_chart_data_standard( this.charts[7],this.data[3],'last12months','bytes',false );

         this.data[4] = await this.refresh_data_per_status( 'month' );
         this.prepare_chart_data_per_status( this.charts[8], this.data[4], 'month', 'mails' );
         
         this.loaded_standard = true;
         this.loaded_per_status = true;

      },

      refresh_pie_graphs() {
         let keys = Object.keys(this.$refs);
         for (var i=0;i<keys.length;i++) {
            if ( keys[i].indexOf('_pie_graph_')==0 ) {
               this.$refs[keys[i]].update();
            }
         }
      },

      async refresh_session() {
         var { errorinfos, api_response } = await this.$api._get_session(this.$router);
         if ( api_response.error==0 && api_response.row ) {
            this.session_row = api_response.row;
         }
      },

      async refresh_page() {
         // Refresh dropdowns :
         await this.$refs.myPLFSelect.refresh_rows();      // chapter3 / search engine
         await this.$refs.myPLFSelect1.refresh_rows();     // chapter1 / synthesis
         await this.$refs.mySTATUSSelect.refresh_rows();   // chapter2 / graphs
         await this.$refs.myGRAPHSelect.refresh_rows();
         await this.$refs.myACCOUNTSelect.refresh_rows();  // chapter2 / account

         // items from dropdowns stat with a _pk = 1
         this.PLFoptions.selected = null;
         if ( this.$refs.myPLFSelect1.items.length>=1 ) {
            this.PLFoptions.selected = this.$refs.myPLFSelect1.items[0]._pk;
         }
         this.ACCOUNToptions.selected = null;
         if ( this.$refs.myACCOUNTSelect.items.length>=1 ) {
            this.ACCOUNToptions.selected = this.$refs.myACCOUNTSelect.items[0]._pk;
         }
         this.GRAPHoptions.selected = null;
         if ( this.$refs.myGRAPHSelect.items.length>=1 ) {
            this.GRAPHoptions.selected = this.$refs.myGRAPHSelect.items[0]._pk;
         }

         // Refresh Synthesis List :
         await this.$refs.mySynthesisList.refresh_rows();  // chapter1 / list
         // Refresh DKIM List :
         await this.$refs.myDKIMList.refresh_rows();

         await this.refresh_data();

         this.refresh_pie_graphs();
      },

      async switch_type(report_type,data_type,account_name='null') {

         this.loaded_per_status = false;
         this.data[4] = await this.refresh_data_per_status( report_type );
         this.prepare_chart_data_per_status( this.charts[8],this.data[4],report_type,data_type );

         this.loaded_per_status = true;
      },

      async build_select_plf(key=null) {
         this.$refs.myPLFSelect.selected = null;
         this.$refs.myPLFSelect1.selected = null;
         this.$refs.myACCOUNTSelect.selected = null;
         this.$refs.myGRAPHSelect.selected = null;

         this.loading = true;
         var { errorinfos, api_response } = await this.$api.getRows(this.$router,'customerreseller/smtpplatforms');
         this.loading = false;
         if ( api_response.error==0 ) {
            var restructured_rows = [];
            // _pk is a manually managed counter, to be used as primary key in ddoSelect(2) arrays
            var _pk = 1;
            for ( var i=0;i<api_response.rows.length;i++) {
               api_response.rows[i]._pk = api_response.rows[i].cus_plf_pk;
               let codes = api_response.rows[i].xxx_sasl_usernames.split(',');
               if ( codes.length==1 ) {
                  api_response.rows[i]._pk = _pk;
                  restructured_rows.push(api_response.rows[i]);
                  _pk++;
               } else {
                  for ( var j=0;j<codes.length;j++) {
                     api_response.rows[i].xxx_sasl_usernames = codes[j];
                     api_response.rows[i]._pk = _pk;
                     _pk++;
                     restructured_rows.push(JSON.parse(JSON.stringify(api_response.rows[i])));
                  }
               }
            }
            restructured_rows.sort(function(a,b) { if (a.xxx_sasl_usernames<b.xxx_sasl_usernames) { return -1; } if (a.xxx_sasl_usernames>b.xxx_sasl_usernames) { return 1; } return 0; } );
            api_response.rows = restructured_rows;
         }
         return { errorinfos, api_response }
      },

      async build_select_graphtype(key=null) {
         this.$refs.myGRAPHSelect.selected = null;
         var errorinfos = null;
         var api_response = {
            error: 0,
            rows: [
               { _pk: 1, value: 'month,mails', text: i18n.t('texts.smtppro_mails_month')     },
               { _pk: 2, value: 'month_cum,mails', text: i18n.t('texts.smtppro_mails_month_cumulative')     },
               { _pk: 3, value: 'last30,mails', text: i18n.t('texts.smtppro_mails_last30')     },
               { _pk: 4, value: 'last12months,mails', text: i18n.t('texts.smtppro_mails_last12months')     },
               { _pk: 5, value: 'month,bytes', text: i18n.t('texts.smtppro_bytes_month')     },
               { _pk: 6, value: 'month_cum,bytes', text: i18n.t('texts.smtppro_bytes_month_cumulative')     },
               { _pk: 7, value: 'last30,bytes', text: i18n.t('texts.smtppro_bytes_last30')     },
               { _pk: 8, value: 'last12months,bytes', text: i18n.t('texts.smtppro_bytes_last12months')     },
            ]
         }
         return { errorinfos, api_response }
      },

      async build_select_status(key=null) {
         this.$refs.mySTATUSSelect.selected = null;
         var errorinfos = null;
         var api_response = {
            error: 0,
            rows: [
               { _pk: 'sent'    , 'status_code': 'sent'    , 'status_label': i18n.t('texts.smtppro_mails_sent')     },
               { _pk: 'bounced' , 'status_code': 'bounced' , 'status_label': i18n.t('texts.smtppro_mails_bounced')  },
               { _pk: 'expired' , 'status_code': 'expired' , 'status_label': i18n.t('texts.smtppro_mails_expired')  },
               { _pk: 'deferred', 'status_code': 'deferred', 'status_label': i18n.t('texts.smtppro_mails_deferred') },
            ]
         }        
         return { errorinfos, api_response }
         
      },

      after_refresh_plf(items) {
         if ( this.$refs.myPLFSelect.selected==null && items.length>=1 ) {
            this.$refs.myPLFSelect.selected = items[0]._pk;
         }
         if ( this.$refs.myPLFSelect1.selected==null && items.length>=1 ) {
            this.$refs.myPLFSelect1.selected = items[0]._pk;
         } 
         if ( this.$refs.myGRAPHSelect.selected==null && items.length>=1 ) {
            this.$refs.myGRAPHSelect.selected = items[0]._pk;
         } 
         if ( this.$refs.myACCOUNTSelect.selected==null && items.length>=1 ) {
            this.$refs.myACCOUNTSelect.selected = items[0]._pk;
         } 
      },

      async change_plf(value,item=null) {
         this.PLFoptions.selected = value;
         this.ACCOUNToptions.selected = value;
         this.$refs.mySynthesisList.refresh_rows();
         this.change_graphtype(this.GRAPHoptions.selected);
      },

      change_graphtype(value,item=null) {
         this.GRAPHoptions.selected = value;
         let row_graph = this.$api._get_by_pk(this.$refs.myGRAPHSelect.items,value);
         let account_pk = this.ACCOUNToptions.selected;
         let row_account = this.$api._get_by_pk(this.$refs.myACCOUNTSelect.items,account_pk);
         if ( row_graph!=null && row_account!=null ) {
            let values = row_graph.value.split(',');
            if ( values.length==2 ) {
               this.switch_type(values[0],values[1],row_account.xxx_sasl_usernames);
            }
         }
      },

      build_comments(row,clean=false) {
         var ret = '';
         //var match1 = row.c_smtp_log_comments.match(/^from=\<([^ ]+)\>.*/);
         //var match2 = row.c_smtp_log_comments.match(/^to=\<([^ ]+)\>.* status=([^ ]+) \((.*)\)/);
         var sender = '';
         if ( row.c_smtp_log_radix && row.c_smtp_log_domain ) {
            sender = row.c_smtp_log_radix+'@'+row.c_smtp_log_domain;
         }
         var recipient = '';
         if ( row.c_smtp_log_radix_out && row.c_smtp_log_domain_out ) {
            recipient = row.c_smtp_log_radix_out+'@'+row.c_smtp_log_domain_out;
         }
         var status='';
         if ( row.c_smtp_log_status_send ) {
            switch (row.c_smtp_log_status_send) {
               case 'sent' : status = i18n.t('texts.search_results_hasbeendelivered'); break;
               case 'bounced' : status = i18n.t('texts.search_results_hasbeenrejected'); break;
               case 'expired' : status = i18n.t('texts.search_results_hasexpired'); break;
               case 'deferred' : status = i18n.t('texts.search_results_hasbeendeferred'); break;
            }
         }
         if ( clean==true ) {
            ret = util.format(i18n.t('texts.search_results_comments_clean'),sender,recipient,status);
         } else {
            ret = util.format(i18n.t('texts.search_results_comments'),sender,recipient,status);
         }
         return ret;
      },

      async export_mails() {
         let csvContent = "data:text/csv;charset=utf-8,";
         let headers = [ i18n.t('headers.datetime_gmt'), i18n.t('headers.messageid'), i18n.t('headers.sender'), i18n.t('headers.recipient'), i18n.t('texts.status'), i18n.t('headers.traces') ];
         csvContent += [
               Object.values(headers).join(";"),
               ...this.search_results.map(item => [ item.d_smtp_log_event_iso, item.c_smtp_log_messageid, item.c_smtp_log_sender, item.c_smtp_log_recipient, item.c_smtp_log_status_send, this.build_comments(item,true) ].join(";"))
            ]
            .join("\n")
            .replace(/(^\[)|(\]$)/gm, "");
         const data = encodeURI(csvContent);
         const link = document.createElement("a");
         link.setAttribute("href", data);
         link.setAttribute("download", "export.csv");
         link.click();
      },

      async export_month_mails() {
            this.loading = true;
            var row_plf = this.$api._get_by_pk(this.$refs.myPLFSelect.items,this.PLFoptions.selected);
            var parameters = { log_direction: 'O', log_sasl_username: row_plf.xxx_sasl_usernames, }
            if ( Array.isArray(this.dates) ) {
               parameters.log_day_from = this.dates[0];
            } else {
               parameters.log_day_from = this.dates;
            }
            if ( this.STATUSoptions.selected!=null ) { parameters.log_status = this.STATUSoptions.selected; }
            parameters.log_range = 'month';

            let { errorinfos, api_response } = await this.$api.getRows( this.$router, this.ws_search_code+'/'+this.ws_key+'/'+this.ws_export_keyword, parameters );
            if ( api_response.error==0 ) {
               if ( api_response.result && api_response.result.link ) {
                  var { errorinfos: errorinfos2, api_response : api_response2 } = await this.$api.getStatic(this.$router,api_response.result.link);
                  if ( api_response2.error && api_response2.error!=0 ) {
                     console.log('api_response2.error='+api_response2.error);
                  } else {
                     let csvContent = "data:text/csv;charset=utf-8,";
                     csvContent += api_response2;
                     const data = encodeURI(csvContent);
                     const link = document.createElement("a");
                     link.setAttribute("href", data);
                     link.setAttribute("download", this.$api._basename(api_response.result.link) );
                     link.click();
                  }
               }
            }
            this.loading = false;
      },

      async search_mails() {
         if ( this.PLFoptions.selected>0 ) {
            this.searching = true;
            this.search_errors = [];
            this.search_results = [];
            this.message_errors = [];
            var row_plf = this.$api._get_by_pk(this.$refs.myPLFSelect.items,this.PLFoptions.selected);
            var parameters = { log_direction: 'O', log_sasl_username: row_plf.xxx_sasl_usernames, }
            if ( Array.isArray(this.dates) ) {
               parameters.log_day_from = this.dates[0];
               if ( this.dates[1] && this.dates[0]!=this.dates[1] ) { parameters.log_day_to = this.dates[1]; }
            } else {
               parameters.log_day_from = this.dates;
            }
            if ( this.STATUSoptions.selected!=null ) { parameters.log_status = this.STATUSoptions.selected; }
            if ( this.search_radix_from && this.search_radix_from.length>0) { parameters.log_radix = this.search_radix_from; }
            if ( this.search_radix_to && this.search_radix_to.length>0 ) { parameters.log_radix_out = this.search_radix_to; }
            if ( this.search_domain_from && this.search_domain_from.length>0 ) { parameters.log_domain = this.search_domain_from; }
            if ( this.search_domain_to && this.search_domain_to.length>0 ) { parameters.log_domain_out = this.search_domain_to; }
            this.loading = true;
            let { errorinfos, api_response } = await this.$api.getRows( this.$router, this.ws_search_code+'/'+this.ws_key+'/'+this.ws_search_keyword, parameters );
            this.loading = false;
            if ( api_response.error==0 ) {
               for ( var i=0;i<api_response.rows.length;i++) {
                  api_response.rows[i]._pk = i;
                  let _date = new Date(api_response.rows[i].d_smtp_log_event.seconds*1000);
                  api_response.rows[i].d_smtp_log_event_iso = _date.toISOString().replace('T',' ').substring(0,19);
                  api_response.rows[i].d_smtp_log_event     = this.$api._d(_date.toISOString(),'timestamp1');
                  api_response.rows[i].c_smtp_log_sender    = api_response.rows[i].c_smtp_log_radix+'@'+api_response.rows[i].c_smtp_log_domain;
                  api_response.rows[i].c_smtp_log_recipient = api_response.rows[i].c_smtp_log_radix_out+'@'+api_response.rows[i].c_smtp_log_domain_out;
                  api_response.rows[i].comments             = this.build_comments(api_response.rows[i]);
               }
            } else {
            }
            this.search_errors = [ errorinfos ];
            this.search_results = api_response.rows;
         }
      },

      async search_message(messageid) {
         if ( this.PLFoptions.selected>0 ) {
            this.message_errors = [];
            var parameters = { log_messageid: messageid };
            this.loading = true;
            let { errorinfos, api_response } = await this.$api.getRows( this.$router, this.ws_search_code+'/'+this.ws_key+'/'+this.ws_search_keyword, parameters );
            this.loading = false;
            if ( api_response.error==0 ) {
               for ( var i=0;i<api_response.rows.length;i++) {
                  api_response.rows[i]._pk = i;
                  let _date = new Date(api_response.rows[i].d_smtp_log_event.seconds*1000);
                  api_response.rows[i].d_smtp_log_event     = this.$api._d(_date.toISOString(),'timestamp1');
                  api_response.rows[i].c_smtp_log_sender    = api_response.rows[i].c_smtp_log_radix+'@'+api_response.rows[i].c_smtp_log_domain;
                  api_response.rows[i].c_smtp_log_recipient = api_response.rows[i].c_smtp_log_radix_out+'@'+api_response.rows[i].c_smtp_log_domain_out;
               }
               this.message_results = api_response.rows;
            } else {
               this.message_errors = [ errorinfos ];
            }
         }
         this.current_messageid = messageid;
         this.showMessageDetail = true;
      },

      configure_form(level,f_disabled,f_create,f_update,f_delete) {
         let _dV = this.levels[level].dialogValues;
         _dV.form_disabled = f_disabled;
         _dV.form_create   = f_create;
         _dV.form_update   = f_update;
         _dV.form_delete   = f_delete;
         this.levels[level].dialogValues = _dV;
      },

      show_dialog(level,show) {
         let _dV = this.levels[level].dialogValues;
         _dV.header_value = _dV.header_value_function(this.levels[level].row);
         _dV.dialogShow = show;
         this.levels[level].dialogValues = _dV;
      },

      hide_dialog(level) {
         this.show_dialog(level,false);
      },

      refresh_errors(level,errors) {
         this.levels[level].errors = errors;
      },

      refresh_row(level,row) {
         this.levels[level].row = row;
      },

      prepare_create_l2() {
         this.levels[1].errors = [];
         this.levels[1].row.dkr_selector = 'smtp-pro';
         this.levels[1].dialogValues.disable_create = true;
         this.levels[1].row.cus_can_change_dkim_selector = this.session_row.cus_can_change_dkim_selector;
      },

      async create_row_l2(router,api_code,row) {
         this.loading = true;
         await this.refresh_session();
         row.cus_pk = this.session_row.cus_pk_customer;
         var { errorinfos, api_response } = await this.$api.createRow(router,api_code,row);
         if ( api_response.error!=0 ) {
            this.levels[1].errors = [errorinfos];
         }
         this.loading = false;
         return { errorinfos, api_response }
      },

      async check_dns_record(row) {
         this.loading = true;
         var { errorinfos, api_response } = await this.$api.updateRow(this.$router,this.levels[1].api_code,row._pk,{format: 'json'},'check');
         if ( api_response.error!=0 ) {
            this.dkim_errors = [ errorinfos ];
         } else {
            this.dkim_errors = [];
         }
         await this.$refs.myDKIMList.refresh_rows();
         this.loading = false;
         return { errorinfos, api_response }
      },

      change_dialogValues(level,property,value) {
         this.levels[level].dialogValues[property] = value;
      },

   },

}
</script>

<style>
.mark, mark {
    padding: .2em;
    background-color: yellow;
}
.graphcontainer {
   width: 50px;
   max-width: 50px;
   height: 50px;
   max-height: 50px;
   margin-left: auto;
   margin-right: auto;
}
</style>